<template>
  <v-sheet
    v-if="items.length"
    class="d-flex align-center products-section"
    color="grey lighten-1"
    height="100%"
  >
    <LoadingWidget v-if="loading" :color="`white`" />
    <v-container v-else class="d-flex flex-column">
      <TitleWidget>Produtos em destaque</TitleWidget>

      <div class="px-4">
        <div class="mx-n4 relative">
          <hooper-container
            v-if="items.length"
            class="slides-container"
            style="height: auto"
            :settings="hooperSettings"
            ref="carousel"
            :wheelControl="false"
            :infiniteScroll="true"
            @slide="updateCarousel"
          >
            <hooper-slide
              class="item py-12"
              v-for="(item, i) in items"
              :key="i"
            >
              <v-sheet width="100%" color="transparent" class="px-4">
                <ProductCardCarrousel v-bind="item" />
              </v-sheet>
            </hooper-slide>
          </hooper-container>
          <div class="slides-nav d-flex justify-space-between">
            <a
              class="d-flex align-center justify-center slides-nav-item"
              @click.prevent="slidePrev"
            >
              <v-icon size="30" color="primary">fas fa-chevron-left</v-icon>
            </a>
            <a
              class="d-flex align-center justify-center slides-nav-item"
              @click.prevent="slideNext"
            >
              <v-icon size="30" color="primary">fas fa-chevron-right</v-icon>
            </a>
          </div>
        </div>
      </div>
      <div class="d-flex justify-center">
        <v-btn
          :to="page"
          height="48px"
          depressed
          rounded
          class="primary px-12 py-3"
          >Ver todos</v-btn
        >
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import { formatToURL } from "../../utils/formatToURL";
import TitleWidget from "../widgets/TitleWidget.vue";
import ProductCardCarrousel from "../cards/ProductCardCarrousel.vue";

const _config = {
  mod: "products",
};

export default {
  data: () => ({
    carouselData: 0,
    loading: true,
    itemsPerPage: 20,
    items: [],
    page: "/produtos",

    hooperSettings: {
      breakpoints: {
        0: {
          itemsToShow: 1,
        },
        600: {
          itemsToShow: 2,
        },
        800: {
          itemsToShow: 3,
        },
        1100: {
          itemsToShow: 4,
        },
      },
    },
  }),

  mounted() {
    this.loading = true;
    this.$rest(_config.mod)
      .get({
        params: {
          itemsPerPage: this.itemsPerPage,
        },
      })
      .then((data) => {
        this.items = data.map(({ title, imgs, id, category }) => ({
          title: title,
          img: this.files + imgs.featured,
          to: `${this.page}/${formatToURL(category.title)}/${formatToURL(
            title
          )}-${id}`,
        }));
      })
      .then(() => (this.loading = false));
  },

  methods: {
    formatToURL,
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.myCarouselData = payload.currentSlide;
    },
  },
  watch: {
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    },
  },

  components: {
    LoadingWidget,
    TitleWidget,
    ProductCardCarrousel,
  },
};
</script>

<style lang="scss" scoped>
.products-section {
  padding-top: 120px;
  // padding-bottom: 100px;
  @media (max-width: 1264px) {
    padding-top: 80px;
    padding-bottom: 60px;
  }
  @media (max-width: 980px) {
    padding-top: 50px;
    padding-bottom: 0px;
  }

  .slides-nav {
    top: 0;
    left: -5%;
    height: 100%;
    position: absolute;
    width: 110%;
    pointer-events: none;
    @media (max-width: 980px) {
      width: 100%;
      left: 0%;
    }
    &-item {
      pointer-events: all !important;
    }
  }
}
.products-section ::v-deep {
  .hooper-next {
    right: -40px;
  }
  .hooper-lef {
    left: -40px;
  }
  ul,
  ol {
    padding: 0 !important;
  }
}
</style>
